import { apiClient } from "../config/api.config";
import { Doctor } from "../types/doctor.definition";
export function getDoctorById(doctorId: string) {
  return apiClient.request({
    method: "get",
    url: `/doctors/${doctorId}`,
  });
}
export function updateDoctor(doctorId: string, data: Partial<Doctor>) {
  return apiClient.request({
    method: "put",
    url: `/doctors/${doctorId}`,
    data,
  });
}
export function getDoctorTimeSlots(doctorId: string) {
  return apiClient.request({
    method: "get",
    url: `/doctor-availability/${doctorId}/time-slots`,
  });
}

export function getDoctorAvailableTimeSlots(doctorId: string) {
  return apiClient.request({
    method: "get",
    url: `/doctor-availability/${doctorId}/available-time-slots`,
  });
}

export function getDoctorTimeSlotsByDate(doctorId: string, date: string) {
  return apiClient.request({
    method: "get",
    url: `/doctor-availability/${doctorId}/time-slots/date/${date}`,
  });
}

export function getDoctorAvailableTimeSlotsByDate(
  doctorId: string,
  date: string
) {
  return apiClient.request({
    method: "get",
    url: `/doctor-availability/${doctorId}/available-time-slots/date/${date}`,
  });
}

export function getDoctorTimeSlotsByDateRange(
  doctorId: string,
  startDate: string,
  endDate: string
) {
  return apiClient.request({
    method: "get",
    url: `/doctor-availability/${doctorId}/time-slots/range`,
    params: {
      startDate,
      endDate,
    },
  });
}

export function getDoctorAvailableTimeSlotsByDateRange(
  doctorId: string,
  startDate: string,
  endDate: string
) {
  return apiClient.request({
    method: "get",
    url: `/doctor-availability/${doctorId}/available-time-slots/range`,
    params: {
      startDate,
      endDate,
    },
  });
}

export function createDoctorTimeSlots(
  doctorId: string,
  data: {
    id?: number;
    daysOfWeek: string[];
    startTime: string;
    endTime: string;
    isRecurring: boolean;
    slotDurationMinutes?: number;
    startDate: string;
    endDate: string;
  }
) {
  return apiClient.request({
    method: "post",
    url: `/doctor-availability/${doctorId}`,
    data,
  });
}

export function deleteDoctorTimeSlot(doctorId: string, timeSlotId: number) {
  return apiClient.request({
    method: "delete",
    url: `/doctor-availability/${doctorId}/time-slot/${timeSlotId}`,
  });
}

export function deleteTimeSlotsByDateRange(
  doctorId: string,
  startDate: string,
  endDate: string
) {
  return apiClient.request({
    method: "delete",
    url: `/doctor-availability/${doctorId}/time-slots/range`,
    params: {
      startDate,
      endDate,
    },
  });
}
export function createDoctor(facilityId: string | number, data: Doctor) {
  return apiClient.request({
    method: "post",
    url: `/healthcare-facilities/${facilityId}/doctors`,
    data,
  });
}

export function unassignDoctorFromFacility(
  facilityId: string | number,
  doctorId: string | number
) {
  return apiClient.request({
    method: "delete",
    url: `/doctors/${doctorId}/remove-healthcare-facility/${facilityId}`,
  });
}

export function assignDoctorToFacility(
  doctorId: string | number,
  facilityId: string | number
) {
  return apiClient.request({
    method: "post",
    url: `/doctors/${doctorId}/assign-healthcare-facility/${facilityId}`,
  });
}
